import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { StaticMetaItemService } from '@mt-ng2/base-service';
import { IClaimValue } from '../model/interfaces/claim-value';

@Injectable()
export class ClaimValueService extends StaticMetaItemService<IClaimValue> {
    constructor(public http: HttpClient) {
        super('ClaimValueService', 'Claim Value', 'ClaimValueIds', '/userRoles/claimValues', http);
    }
}
